export const SET_THEME = 'SET_THEME';
export const SET_THEME_LOADING = 'SET_THEME_LOADING';
export const SET_AGENCY_DATA = 'SET_AGENCY_DATA'
export const SET_AGENCY_DATA_LOADING = 'SET_AGENCY_DATA_LOADING';
